import { isElectronApp } from '#~/electron/utils.js';
import { NotFoundError } from '#~/error/index.js';
import { Button } from '@studio/design-system/button';
import { Centered } from '@studio/design-system/overlay';
import type { T_Maybe } from '@tryiris-ai/js-types';

/**
 * Missing/Not Found/404-style route.
 *
 * @throws Always throws a `NotFoundError`.
 */
export const NotFound = (props: { message?: T_Maybe<string> }): any => {
  if (isElectronApp()) {
    return (
      // ENG-4034: Centered wraps children in an inline-block (content-width,
      // left-aligned), so the stacked title/message/button rendered ragged.
      // A centered flex column with text-center aligns everything on the axis.
      <Centered>
        <div className='flex flex-col items-center gap-8 text-center'>
          <h1>Page Not Found</h1>
          {!!props.message && <p>{props.message}</p>}
          <a href='/'>
            <Button>Go to home page</Button>
          </a>
        </div>
      </Centered>
    );
  }
  throw new NotFoundError(props.message);
};
